import launchDarklyConfig, { FlagConfig } from "flags/launchDarklyConfig";
import * as LDClient from "launchdarkly-js-client-sdk";

const fallbackFlags = Object.keys(launchDarklyConfig).reduce((accumulated, current) => {
  accumulated[current] = (launchDarklyConfig as { [key: string]: FlagConfig })[current].fallbackFlagValue;

  return accumulated;
}, {} as LDClient.LDFlagSet);

export default fallbackFlags;
